import 'next/stylesheets/components/field-prototype-setting.scss';
